.container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.label {
  font-size: 0.8125em;
}

.buttonsContainer {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.button {
  flex: 1;
  padding: 0.5rem 0.5rem;
  border: none;
  border-radius: 3px;
  background: transparent;
  font-size: 0.8125em;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  white-space: nowrap;
  color: var(--font-color);
}

@media (hover: hover) {
  .button:hover {
    background: var(--bg-light-grey);
  }
}

@media (hover: none) {
  .button:active {
    background: var(--bg-light-grey);
  }
}

.button.selected {
  background: var(--bg-light-grey);
}
